import { FC, useContext, useEffect, useState } from "react";
import { BoardContext, SocketContext, TeamContext, UserContext } from "../../../../context";
import { CornerCirclesBackground, MainButton, RegularInput } from "../../../atoms";

import logoUppiness from "../../../../assets/icons/logoUppiness.svg";
import { useTranslation } from "react-i18next";

interface IRejoinTheGame {
    setIsUserSelected?(value: boolean): void;
}

const RejoinTheGame: FC<IRejoinTheGame> = ({setIsUserSelected}) => {
    const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { roomUsers } = useContext(TeamContext);
    const { setUserDataWhenUserRejoinsTheGame } = useContext(UserContext);
    const { setDidUserRejoinTheGame } = useContext(BoardContext);
    const [email, setEmail] = useState("");
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
    const { reConnectToServer } = useContext(TeamContext);

    console.log('email', email)

    const numberOfPlayers: string = localStorage.getItem("numberOfPlayers") || "0";
    const numberOfPlayersTypeNumber: number = parseInt(numberOfPlayers);

    const rejoinButtonDisabled = email == "";
    
    const listOfUsersSelectBox = () => {
        if (numberOfPlayersTypeNumber) 
            return(
                <select className="select_box_users_list" value={email}  onChange={(event: any) => setEmail(event.target.value)} >
                {
                    <option value={""}></option>
                }
                {
                        
                        Array.apply(null, Array(numberOfPlayersTypeNumber)).map( (_, index: number) => {
                            return (
                                <option value={localStorage[`userEmail${index}`]} key={index}>{localStorage[`userEmail${index}`]}</option>
                            )
                        })
                }
                </select>
            )
        
        return <div></div>;
    }

    const rejoinTheGame = () => {
        if (setIsUserSelected) setIsUserSelected(true);
        setUserDataWhenUserRejoinsTheGame(email);
        socket?.emit("reconnection", {email: email, matchId: urlTokenExtracted});
        setDidUserRejoinTheGame(true);
    }

    useEffect(() => {
        roomUsers();
    }, [roomUsers]);

    const handleKeyPress = (event: any) => {
        setEmail(event);
    }

    return (
        <CornerCirclesBackground>
            <div className="center_horizontally_and_vertically">
                <div className="log_in">
                    <img className="log_in_logo" src={logoUppiness} alt="Uppiness Logo" />

                    <div className="elipse" />

                    <div className="center_rejoin_elements">
                        <div className="rejoin_elements_holder">
                            <div className="input_wrapper" style={{ paddingTop: '30px' }}>
                                <div className="regular_input">
                                    <div> {t("chooseOneOfTheOfferedEmails")} </div>
                                    {listOfUsersSelectBox()}
                                </div>
                            </div>

                            <div className="rejoin_button_wrapper">
                                <form onSubmit={() => rejoinTheGame()}>
                                    <div className="main_button-wrapper">
                                        <MainButton
                                            type="big"
                                            text={t("rejoinTheGameText")}
                                            clickHandler={() => rejoinTheGame()}
                                            disabled={rejoinButtonDisabled}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CornerCirclesBackground>

    )
}

export default RejoinTheGame;